
import { format, isToday } from "date-fns";
import CustomTooltip from "../../../Common/Tooltip/CustomTooltip";
import { AppConstant } from "../../../../Assests/AppConstant";
import WhiteTooltip from "./WhiteTooltip";
import { useRef, useState } from "react";



const TodayTypo = ({ date, onClick, locale,isNonOperational ,isClosedToday}) => {
 const [showTooltip, setShowTooltip] = useState(false);
const infoRef = useRef(null);
  
  return (
    <div>
      <div
        style={{
          fontWeight: isToday(date) ? "bold" : "inherit",
        }}
        color={isToday(date) ? "primary" : "inherit"}
        className={onClick ? "rs__hover__op" : "d-flex gap-1"}
        onClick={(e) => {
          e.stopPropagation();
          if (onClick) onClick(date);
        }}
      >
        {format(date, "dd", { locale })}  
        {isNonOperational && 
        <>
        <div
        className="f-16 pointer color-red "
          data-testid={AppConstant.dataTestId.operational_days}
          data-tip={'Non Operational Day'}
          data-for={AppConstant.dataTestId.operational_days}
        > [!]</div> 
        <CustomTooltip
        id={AppConstant.dataTestId.operational_days}
        position="bottom"
        type="dark"
        multiline={true}
      />
      </>
        }

           
      </div>
      <div
        color={isToday(date) ? "primary" : "inherit"}
        style={{
          fontWeight: isToday(date) ? "bold" : "inherit",
          fontSize: 11,
        }}
      >
        {format(date, "eee", { locale })} 
        
      </div>
      {isClosedToday && isClosedToday.length ? 
      <>
      <div className="f-12"
      >{`Holiday`}
       <span
          className=" ms-2"
            ref={infoRef}
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
        >
          <i className="fa-solid fa-circle-info fa-sm"></i>
        </span>
        </div>
        
        <WhiteTooltip show={showTooltip} anchorRef={infoRef}>
  <div>
    <strong className="mb-1 d-block">Holiday Details</strong>

    <ul className="list-unstyled mb-0">
      {isClosedToday.map((el, i) => (
        <li
          key={i}
          className="d-flex align-items-center mb-1 break-tooltip-item"
        >
          <div
            className="code__legend"
            style={{ backgroundColor: el.dockColor }}
          />
          <div>
          <div className='fw-600'>
            {`${el.Name} - ${el.Description}`}
          </div>
        
          </div>
        </li>
      ))}
    </ul>
  </div>
</WhiteTooltip>
       </>
        :""}
    </div>
  );
};

export default TodayTypo;
